import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Sparkles, ArrowRight, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TrialBanner({ teamId }) {
  const [trial, setTrial] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!teamId) return;
    axios.get(`${API}/payments/subscription/${teamId}`)
      .then((res) => { if (res.data?.trial) setTrial(res.data); })
      .catch(() => {});
  }, [teamId]);

  if (!trial || dismissed) return null;
  const days = trial.trial_days_left;

  return (
    <div className="rounded-xl border-2 border-primary bg-primary/5 px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="trial-banner">
      <Sparkles className="h-7 w-7 text-primary flex-shrink-0" />
      <div className="flex-1">
        <p className="font-heading font-black uppercase text-primary text-lg" data-testid="trial-banner-days">
          Elite Free Trial — {days} day{days === 1 ? '' : 's'} left
        </p>
        <p className="text-sm text-muted-foreground">
          You have full access to every PAC feature. Pick a plan before your trial ends to keep the momentum going.
        </p>
      </div>
      <Button onClick={() => navigate('/settings')} data-testid="trial-banner-choose-plan-btn">
        Choose a Plan <ArrowRight className="h-4 w-4 ml-2" />
      </Button>
      <button
        onClick={() => setDismissed(true)}
        className="text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Dismiss"
        data-testid="trial-banner-dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
